// Regras puras do checkout de assinatura (sem React, sem rede). O backend é
// a fonte da verdade do valor cobrado; estas contas só mostram ao usuário o
// mesmo número antes do clique — por isso o arredondamento espelha
// backend/src/services/SubscriptionService/helpers/desconto.ts.
import { i18n } from "../../translate/i18n";

export const round2 = (x) => Math.round(x * 100) / 100;

// Moeda da plataforma é sempre real; só o texto ao redor muda de idioma.
export const formatBRL = (value) =>
  `R$ ${Number(value || 0).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const aplicaDesconto = (bruto, percent) => {
  const desconto = round2((bruto * Number(percent || 0)) / 100);
  return { bruto, desconto, total: round2(bruto - desconto) };
};

// Contratação nova: preço do período escolhido, desconto só no Pix.
export const totalDoCiclo = ({ prices, period, method, pixDiscountPercent }) => {
  const bruto = Number(prices?.[period]) || 0;
  if (method !== "PIX" || bruto <= 0) {
    return { bruto, desconto: 0, total: bruto };
  }
  return aplicaDesconto(bruto, pixDiscountPercent);
};

// Fatura aberta (`POST /subscriptions/invoices/:id/pay`): `value` é líquido,
// bruto = value + discount. Pix já emitido para a fatura mantém o valor dela;
// outro meio virando Pix recebe o desconto atual (PagaFaturaAbertaService).
export const valoresDaFatura = ({ fatura, method, pixDiscountPercent }) => {
  const value = Number(fatura?.value) || 0;
  const discount = Number(fatura?.discount) || 0;
  const bruto = round2(value + discount);
  if (method !== "PIX") {
    return { bruto, desconto: 0, total: bruto };
  }
  if (fatura?.paymentMethod === "PIX") {
    return { bruto, desconto: discount, total: value };
  }
  return aplicaDesconto(bruto, pixDiscountPercent);
};

export const parcelaLabel = (total, installments) => {
  const n = Math.max(1, Number(installments) || 1);
  return i18n.t("subscription.checkout.installmentLabel", {
    n,
    value: formatBRL(round2(Number(total || 0) / n)),
  });
};

// Combinações aceitas pelo backend: MENSAL × (CARD_RECURRING | PIX),
// ANUAL × (CARD_SAVED | PIX); fatura UPGRADE no cartão é cobrança avulsa.
export const metodoPara = (period, tab, kind) => {
  if (tab === "pix") return "PIX";
  if (kind === "UPGRADE") return "CARD_SAVED";
  return period === "ANUAL" ? "CARD_SAVED" : "CARD_RECURRING";
};

// Sem public key do Mercado Pago o Brick de cartão não carrega: a aba
// Cartão continua visível, desabilitada (com aviso), e só o Pix fica ativo.
export const abasDisponiveis = ({ publicKey }) => [
  { id: "card", disabled: !publicKey },
  { id: "pix", disabled: false },
];

// `POST /subscriptions` só atende quem não tem assinatura vigente; fatura
// aberta de assinatura ACTIVE/PAST_DUE se paga pela rota da fatura.
export const modoDoCheckout = ({ openInvoice, subscription }) =>
  openInvoice && ["ACTIVE", "PAST_DUE"].includes(subscription?.status)
    ? "invoice"
    : "new";

export const maxParcelas = (period, kind) =>
  period === "ANUAL" && kind !== "UPGRADE" ? 12 : 1;

export const mesesEconomizados = (prices) => {
  const mensal = Number(prices?.MENSAL) || 0;
  const anual = Number(prices?.ANUAL) || 0;
  if (!mensal || !anual) return 0;
  return Math.max(0, Math.floor(12 - anual / mensal + 0.05));
};
